<template>
    <div id="channellist" class="screen">
        <div id="groups">
            <ul>
                <li 
                    v-for="group in groups" 
                    :key="group.id"
                    :style="{ 'background-color': group.color }"
                    @click="toGroup(group.id)"
                    class="group" 
                 >
                    <div>
                        {{group.name}}
                    </div>
                </li>
            </ul>
        </div>
        <Channels
                :filters="filters"
                :filteredChannels="filteredChannels"
                @openChannel="openChannel"
                @apiGetChannelList="apiGetChannelList"
                @clearSearch="clearSearch"
        ></Channels>

        <Epg
                :formattedDate="formattedDate"
                :archiveProgramInfo="archiveProgramInfo"
                @epgPrevDay="epgPrevDay"
                @epgNextDay="epgNextDay"
                @openProgram="openProgram"
        ></Epg>
    </div>

</template>

<script>
    import Channels from './Channels.vue'
    import Server from '../libs/server'
    import Moment from 'moment';

    import {mapState, mapActions} from 'vuex'

    import Epg from './Epg.vue';

    export default {
        props: ['teletekaEnabled'],
        components: {Channels, Epg},
        data() {
            return {
                hidden: [],
                filteredChannels: [],
                filters: {
                    search: '',
                    favorites: false
                },
                formattedDate: Moment().locale('ru').format('DD MMMM YYYY'),
                archiveProgramInfo: {}
            }
        },
        computed: {
            ...mapState({
                channels: state => state.channels.channels,
                channel: state => state.channels.currentChannel,
                groups: state => state.channels.groups,
                favoriteChannels: state => state.favoriteChannels.favoriteChannels,
//                epg: state => state.epg.epg,
                epgChannel: state => state.epg.epgChannel,
                epgList: state => state.epg.epgList,
                epgDate: state => state.epg.epgDate,
                tab: state => state.tab.tab
            }),
        },
        watch: {
            'filters.search'() {
                this.filters.favorites = false;
                if (this.filters.search) {
                    this.filteredChannels = this.channels.filter(channel => channel.name.toLowerCase().includes(this.filters.search.toLowerCase()));
                }
                else {
//                    this.filteredChannels = this.channels;
                    this.filteredChannels = [];
                }
            },
            channel(newValue, oldValue) {
                if (this.channel && (oldValue.id !== newValue.id)) {
                    this.setEpgChannel(this.channel)
                        .then(() => {
                            this.getEpg();
                        });
                }
            },
            channels() {
                if (this.filters.favorites) {
                    this.openFavoriteGroup();
                }
                else if (this.filters.search) {
                    this.filteredChannels = this.channels.filter(channel => channel.name.toLowerCase().includes(this.filters.search.toLowerCase()));
                }
            }
        },
        methods: {
            ...mapActions([
                'getEpg',
                'setEpgChannel',
                'changeEpgDate'
            ]),
            apiGetChannelList(show, protectionCode, ignoreLastUpdated, callback) {
                return this.$emit('apiGetChannelList', show, protectionCode, ignoreLastUpdated, callback);
            },
            openFavoriteGroup() {
                this.filters.favorites = true;
                this.filteredChannels = this.channels.filter(channel => channel.is_favorite === true);
            },
            saveArchiveProgramInfo({index, channelId, epgList, epgDate, utStart}) {
                this.archiveProgramInfo = {
                    index: index,
                    utStart: utStart,
                    channelId: channelId,
                    epgList: epgList,
                    epgDate: epgDate.clone()
                }
            },
            countProgramEnd(index) {
                return new Promise(resolve => {
                    this.getNextProgram(index)
                        .then(nextProgram => {
                            resolve(nextProgram.ut_start);
                        });
                });
            },
            getUpdatedProgramInfo() {
                return new Promise(resolve => {
                    let program;

                    this.getNextProgram()
                        .then(nextProgram => {
                            program = nextProgram;

                            resolve(program);
                        });
                });
            },
            openChannel(channel) {
                let callback = () => {
                    this.changeEpgDate({epgDate: Moment().locale('ru')});

                    this.formattedDate = this.epgDate.format('DD MMMM YYYY');

                    this.setEpgChannel(channel)
                        .then(() => {
                            this.getEpg();
                        });
                };

                this.$emit('openChannel', {channel, callback});
            },
            getNextProgram(index) {
                return new Promise(resolve => {
                    let channelId;
                    let epgList;
                    let epgDate;

                    if (index === undefined) { // Если не задан индекс, то переключаем следующую программу по архиву
                        index = this.archiveProgramInfo.index;
                        channelId = this.archiveProgramInfo.channelId;
                        epgList = this.archiveProgramInfo.epgList;
                        epgDate = this.archiveProgramInfo.epgDate;
                    }
                    else { // Если есть индекс отдаем следующую программу для epg расписания
                        channelId = this.epgChannel.id;
                        epgList = this.epgList;
                        epgDate = this.epgDate;
                    }

                    if (isNaN(index)) {
                        console.error('Индекс программы в getNextProgram - не число!')
                    }

//                    if (!index) index = this.archiveProgramInfo.index;

                    let nextProgram = epgList[index + 1]; // берем следующую по индексу передачу

//                     если в текущем дне есть следующая передача то выбираем ее, если нет то смотрим на первую передачу следующего дня
                    if (nextProgram) {
                        nextProgram.index = index + 1;
                        resolve(nextProgram);
                    }
                    else {
                        let date = epgDate.clone();
                        let nextDay = date.add(1, 'd');
                        Server.getEpg(channelId, nextDay.format('DDMMYY'), (err, data) => {
                            nextProgram = data.epg[0];
                            nextProgram.index = 0;

                            nextProgram.newProgramInfo = {
                                index: 0,
                                channelId: channelId,
                                epgList: data.epg,
                                epgDate: nextDay
                            };

                            resolve(nextProgram);
                        });
                    }
                });
            },
            saveCurrentProgramToArchiveInfo(program) {
                if (!program) {
                    this.archiveProgramInfo = {};
                    return;
                }

                let currentProgramIndex = this.epgList.findIndex(value => +value.ut_start === +program.start);

                this.saveArchiveProgramInfo({
                    index: currentProgramIndex,
                    utStart: program.start,
                    channelId: this.epgChannel.id,
                    epgList: this.epgList,
                    epgDate: this.epgDate
                });
            },
            openProgram(program, index) {
                this.saveArchiveProgramInfo({
                    index,
                    utStart: program.ut_start,
                    channelId: this.epgChannel.id,
                    epgList: this.epgList,
                    epgDate: this.epgDate
                });


                if (this.teletekaEnabled && program.teleteka) {
                    this.$emit('openChannel',
                        {
                            channel: this.epgChannel,
                            program: {
                                name: program.progname,
                                start: +program.ut_start,
                                end: +program.ut_end,
                                duration: +program.duration,
                                teleteka: program.teleteka
                            }
                        }
                    );
                }
                else {
                    this.$emit('openChannel',
                        {
                            channel: this.epgChannel,
                            program: {
                                name: program.progname,
                                start: +program.ut_start,
                                end: +program.ut_end
                            }
                        }
                    );
                }
            },
            clearSearch() {
                this.filteredChannels = [];
                this.filters.search = '';
            },
            toGroup(id) {
                this.clearSearch();
                this.$nextTick()
                    .then(() => {
                        if (id) { // обычная группа
                            this.filters.favorites = false;
                            if (document.querySelector('#channelGroup' + id))
                                document.querySelector('#channelGroup' + id).scrollIntoView(true);
                        }
                        else { // избранные с id == 0
                            this.openFavoriteGroup();
                        }
                    });
            },
            epgNextDay() {
                let date = this.epgDate.clone();

                this.changeEpgDate({days: 1});
                this.formattedDate = date.add(1, 'd').format('DD MMMM YYYY');
                this.getEpg();
            },
            epgPrevDay() {
                let date = this.epgDate.clone();

                this.changeEpgDate({days: -1});
                this.formattedDate = date.subtract(1, 'd').format('DD MMMM YYYY');
                this.getEpg();
            }
        }
    }
</script>

<style>
    #channellist {
        z-index: 10;
        background: rgba(0, 0, 0, .75);
    }

    #groups, #channels, #epg {
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        overflow-y: scroll;
        /*overflow-y: visible;*/
        width: 240px;
    }

    #groups ul, #groups li {
        list-style: none;
        margin: 0;
        padding: 0;
        cursor: pointer;
    }

    #groups li div {
        text-transform: uppercase;
        padding: 24px 10px;
        background: linear-gradient(to top, rgba(0, 0, 0, .25), rgba(0, 0, 0, .1));
    }

    #groups li:hover div {
        background: linear-gradient(to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .2));
    }

    #channels {
        left: 240px;
        width: 450px;
    }

    #channels a {
        color: #fff;
    }

    #channels > ul {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .channels_actions {
        border-bottom: solid 1px rgba(255, 255, 255, .1);
        border-right: solid 1px rgba(255, 255, 255, .1);
        height: 67px;
    }

    .channels_actions > div {
        padding: 24px 30px;
        display: inline-block;
        cursor: pointer;
    }

    .channels_actions > div:hover {
        background-color: rgba(0, 0, 0, .75);
    }

    .channels_top-bar {
        border-bottom: solid 1px rgba(255, 255, 255, .1);
        border-right: solid 1px rgba(255, 255, 255, .1);

        transform: translate(-100%);
        transition: transform .2s;
        position: absolute;
        height: 67px;
    }

    /*.channels_search {*/
    /*border-bottom: solid 1px rgba(255, 255, 255, .1);*/
    /*border-right: solid 1px rgba(255, 255, 255, .1);*/

    /*transform: translate(-100%);*/
    /*transition: transform .2s;*/
    /*position: absolute;*/
    /*height: 67px;*/
    /*}*/

    /*.channels_search.active {*/
    .channels_top-bar.active {
        transform: translate(0);
        position: relative;
    }

    /*.channels_search.fixed {*/
    .channels_top-bar.fixed {
        position: fixed;
        width: 443px;
        z-index: 999;
    }

    .channels_search.fixed input {
        background: rgba(0, 0, 0, 0.9);
    }

    /*.channels_search > .back {*/
    .channels_top-bar > .back {
        width: 10%;
        cursor: pointer;
        margin-right: -5px;
        /* padding: 10px 0px; */
        text-align: center;
        /*display: none;*/
        display: inline-block;
        /*padding: 20px 0px;*/
        /*padding: 22px 0px;*/
        vertical-align: middle;
        height: 100%;
    }

    /*.channels_search > .back i {*/
    .channels_top-bar > .back i {
        display: block;
        margin-top: 26px;
    }

    /*.channels_search > .back:hover {*/
    .channels_top-bar > .back:hover {
        background-color: rgba(0, 0, 0, .75);
    }

    .channels_search input {
        /*width: 100%;*/
        width: 90%;
        /*height: 40px;*/
        border: none;
        outline: none;
        /*background: transparent;*/
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        /*padding: 20px;*/
        font-size: 20px;
        box-sizing: border-box;
        height: 100%;
        vertical-align: middle;
    }

    #epg {
        left: 678px;
        width: calc(100% - 690px);
        /*width: 100%;*/
        /*overflow-x: hidden;*/
    }

    #epg .day-title {
        text-align: center;
        margin-top: 30px;
    }

    #epg .epg_controls_button {
        position: absolute;
        top: 30px;
        font-size: 30px;
        cursor: pointer;
    }

    .epg_controls .next-button {
        right: 80px;
    }

    .epg_controls .prev-button {
        left: 80px;
    }

    .epg_programs {
        padding: 20px;
        padding-top: 100px;
    }

    .epg_programs .program-item td {
        /*margin-bottom: 10px;*/
        padding: 10px;
    }

    .epg_programs th {
        padding-right: 20px;
        padding-bottom: 20px;
    }

    .epg_programs .program-item a {
        color: #fff;
        text-decoration: none;
    }

    .epg_programs .program-item a:hover {
        /*text-decoration: underline;*/
        border-bottom: 1px solid #fff;
    }

    .epg-fixed {
        position: fixed;
        width: calc(100% - 690px);
        background: rgba(0, 0, 0, 0.73);
        padding-bottom: 10px;
    }

    .programs_empty-text {
        margin-top: 100px;
        text-align: center;
        color: #aaa;
    }

    .icon-control-play-filled {
        width: 0;
        height: 0;
        border-left: 11px solid transparent;
        border-right: 11px solid transparent;
        border-bottom: 16px solid #999999;
        transform: rotate(90deg);
        display: block;
        border-radius: 2px;
        margin-left: -1px;
    }

    .channels_edit .edit-text {
        font-size: 13px;
        display: inline-block;
        width: 90%;
        vertical-align: middle;
    }

    .channel.dim {
        opacity: 0.4;
    }

    .channel_body.disabled {
        pointer-events: none;
    }

    .hide-channel-button:hover i:after {
        content: '';
        display: block;
        position: absolute;
        width: 80%;
        height: 1px;
        background: #fff;
        transform: rotate(-45deg);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }

    .show-channel-button i:after {
        content: '';
        display: block;
        position: absolute;
        width: 80%;
        height: 1px;
        background: #fff;
        transform: rotate(-45deg);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }

    .show-channel-button:hover i:after {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// ChannelList.vue?ad919ff8